import GlobalAlert from './GlobalAlert';

export default GlobalAlert;
